import {URL_PRIVACY_POLICY, URL_TERMS_AND_CONDITIONS} from "@/lib/links.ts";

import styles from "./SubscribeDropdown.module.scss";

export const SubscribeDropdownFooter = () => (
  <div className={styles.footer}>
    <p className={styles.termsText}>
      By subscribing you agree to the{" "}
      <a href={URL_TERMS_AND_CONDITIONS} target="_blank" rel="noopener noreferrer" className={styles.termsLink}>
        Terms &amp; Conditions
      </a>{" "}
      and{" "}
      <a href={URL_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer" className={styles.termsLink}>
        Privacy Policy
      </a>
    </p>
  </div>
);
